import { ResponsiveDialogProvider } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { CoursesSortButton } from './filter/courses-sort-button';
import { CoursesFilterButton } from './filter/courses-filter-button';
import { useJobportalCoursesStore } from '@eliadmin/core/src/stores/jobportal-courses-store';

export const coursesortOptions = [
  { label: 'Najstaršie', value: 'created_at:asc' },
  { label: 'Najnovšie', value: 'created_at:desc' },
];

export const JobportalCoursesHeader = () => {
  const { setFilter, applyFilter, filter } = useJobportalCoursesStore();

  const handleFilterChange = (filter: {
    order: 'asc' | 'desc';
    orderBy: 'created_at' | 'salary' | 'distance';
  }) => {
    setFilter(filter);
    applyFilter(filter);
  };

  return (
    <div className="mb-8 flex flex-col gap-6">
      <h1 className="w-full text-3xl font-bold text-foreground md:block">Vzdelávacie kurzy</h1>
      <div className="hidden items-center justify-start gap-8 md:flex">
        {coursesortOptions.map((option, index) => (
          <button
            type="button"
            aria-pressed={
              filter.order === option.value.split(':')[1] &&
              filter.orderBy === option.value.split(':')[0]
            }
            key={index}
            className={cn(
              'cursor-pointer text-base font-normal text-primary',
              filter.order === option.value.split(':')[1] &&
                filter.orderBy === option.value.split(':')[0]
                ? 'font-semibold'
                : '',
            )}
            onClick={() =>
              handleFilterChange({
                order: option.value.split(':')[1] as 'asc' | 'desc',
                orderBy: option.value.split(':')[0] as 'created_at' | 'salary' | 'distance',
              })
            }
          >
            {option.label}
          </button>
        ))}
      </div>
      <div className="flex flex-col md:hidden">
        <ResponsiveDialogProvider>
          <div className="flex gap-4">
            <CoursesSortButton />
            <CoursesFilterButton />
          </div>
        </ResponsiveDialogProvider>
      </div>
    </div>
  );
};
